import apiV2 from "api-v2";
import type { QuoteSupportingDocument } from "../types/quote.type";

interface QuoteAttachmentRequest {
	inviteId: number;
	quoteId: number;
}

export const getQuoteAttachments = async (
	request: QuoteAttachmentRequest
): Promise<QuoteSupportingDocument[]> => {
	const response = await apiV2.get<{ data: QuoteSupportingDocument[] }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/attachments`
	);
	return response.data.data;
};

/**
 * Batch: return all attachments for every quote table, keyed by quote ID.
 */
export const getAllQuoteAttachments = async (
	inviteId: number
): Promise<Record<number, QuoteSupportingDocument[]>> => {
	const response = await apiV2.get<{ data: Record<number, QuoteSupportingDocument[]> }>(
		`rfx-invite/${inviteId}/quotes/attachments`
	);
	return response.data.data;
};

export const deleteQuoteAttachment = async (
	request: QuoteAttachmentRequest,
	fileId: number
): Promise<void> => {
	await apiV2.delete(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/attachments/${fileId}`
	);
};
